import SectionCard from './SectionCard';

const TONES = {
  crit: { bg: '#fdfbfa', border: '#e8dad6', dot: '#9a564a', days: '#9a564a' },
  warn: { bg: '#fefcf8', border: '#ebdcb9', dot: '#8a6a1f', days: '#8a6a1f' },
  info: { bg: '#f9fafb', border: '#d9e0eb', dot: '#3a4a66', days: '#3a4a66' },
};

/**
 * CriticalAlerts — the top-5 engine alerts (or the all-clear / no-companies
 * placeholder). Owns the alert→row mapping (moved verbatim from the page);
 * every row deep-links to the Alerts page.
 */
export default function CriticalAlerts({ alerts, totalCompanies, onOpenAlerts }) {
  const rows = alerts.length
    ? alerts.slice(0, 5).map((item) => ({
      company: item.companyName,
      city: item.companyCity || '',
      state: item.companyState || '',
      description: `${item.formCode} ${item.item}`,
      days: item.daysOverdue < 0 ? `OVERDUE ${Math.abs(item.daysOverdue)}d` : `${item.daysOverdue} days left`,
      tone: item.priority === 'critical' ? 'crit' : 'warn',
      estimated: item.estimated,
      agmNotSet: item.agmNotSet,
      agmNotSetForCurrentFy: item.agmNotSetForCurrentFy,
    }))
    : totalCompanies > 0
      ? [{ company: 'All companies', description: 'No overdue or due-soon filings detected', days: '✔', tone: 'info' }]
      : [{ company: 'No companies added', description: 'Add companies to see compliance alerts', days: '—', tone: 'info' }];

  return (
    <SectionCard icon="critical" iconTone="#9a564a" title="Critical Alerts" action={{ label: 'View All', onClick: onOpenAlerts }}>
      <div className="p-4 flex flex-col gap-2">
        {rows.map((item, i) => {
          const tone = TONES[item.tone] || TONES.info;
          return (
            <div
              key={`${item.company}-${item.description}-${i}`}
              className="flex items-start gap-2.5 px-3 py-2.5 rounded-[12px] border transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] hover:translate-x-1 hover:shadow-[0_4px_12px_-4px_rgba(122,112,96,0.05)] cursor-pointer"
              style={{ background: tone.bg, borderColor: tone.border }}
              onClick={onOpenAlerts}
            >
              <span className="w-[6px] h-[6px] rounded-full mt-1.5 shrink-0" style={{ background: tone.dot }} />
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-[12px] text-[#08111f] truncate">{item.company}</div>
                <div className="text-[10.5px] text-[#7a7060] truncate">
                  {item.city && item.state && item.city.toLowerCase() !== item.state.toLowerCase()
                    ? `${item.city}, ${item.state}`
                    : item.city || item.state || '-'}
                  {item.agmNotSet && <span className="font-semibold" style={{ color: '#8a6a1f' }}> · AGM (missing)</span>}
                  {!item.agmNotSet && item.agmNotSetForCurrentFy && <span className="font-semibold" style={{ color: '#3a4a66' }}> · AGM outstanding (this year)</span>}
                </div>
                <div className="text-[11px] text-[#7a7060] mt-[1px] truncate">
                  {item.description}
                  {item.estimated && <span className="ml-1 text-[9px] italic" style={{ color: '#8a6a1f' }}>(estimated)</span>}
                </div>
              </div>
              <div className="text-[10.5px] font-bold whitespace-nowrap shrink-0 ml-2" style={{ color: tone.days }}>{item.days}</div>
            </div>
          );
        })}
      </div>
    </SectionCard>
  );
}
